"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddComponent = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var AddComponent = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M10.8 10.8H1.2V3A1.8 1.8 0 013 1.2h7.8v9.6zM10.8 13.2v9.6H3A1.8 1.8 0 011.2 21v-7.8h9.6zM13.2 13.2v9.6H21a1.8 1.8 0 001.8-1.8v-7.8h-9.6zM18 1.2a1.2 1.2 0 011.2 1.2v2.4h2.4a1.2 1.2 0 010 2.4h-2.4v2.4a1.2 1.2 0 11-2.4 0V7.2h-2.4a1.2 1.2 0 110-2.4h2.4V2.4A1.2 1.2 0 0118 1.2z" })); };
exports.AddComponent = AddComponent;
//# sourceMappingURL=add-component.js.map